"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useWaveRankReward } from "@/hooks/waves/useWaveRankReward";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
interface WaveSmallLeaderboardItemOutcomesProps {
  readonly drop: ApiDrop;
  readonly isMobile?: boolean | undefined;
}
export const WaveSmallLeaderboardItemOutcomes: React.FC<WaveSmallLeaderboardItemOutcomesProps> = t0 => {
  const $ = _c(36);
  const {
    drop,
    isMobile: t1
  } = t0;
  t1 === undefined ? false : t1;
  const [isTouch] = useState(_temp);
  const [isOpen, setIsOpen] = useState(false);
  let t2;
  if ($[0] !== isOpen || $[1] !== isTouch) {
    t2 = e => {
      if (isTouch) {
        e.stopPropagation();
        setIsOpen(!isOpen);
      }
    };
    $[0] = isOpen;
    $[1] = isTouch;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClick = t2;
  let t3;
  if ($[3] !== drop.rank || $[4] !== drop.wave.id) {
    t3 = {
      waveId: drop.wave.id,
      rank: drop.rank
    };
    $[3] = drop.rank;
    $[4] = drop.wave.id;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    nicTotal,
    repTotal,
    manualOutcomes,
    isLoading
  } = useWaveRankReward(t3);
  const totalOutcomes = (nicTotal ? 1 : 0) + (repTotal ? 1 : 0) + manualOutcomes.length;
  if (totalOutcomes === 0 && !isLoading) {
    return null;
  }
  if (isLoading) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="tw-h-6 tw-w-16 tw-animate-pulse tw-rounded-lg tw-bg-iron-800" />;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-text-xs tw-font-medium tw-text-iron-400">Outcome</span>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== nicTotal) {
    t5 = !!nicTotal && <div className="tw-flex tw-items-center tw-justify-between"><span className="tw-text-xs tw-font-medium tw-text-iron-300">NIC</span><span className="tw-text-xs tw-font-medium tw-text-blue-200/90">{nicTotal}</span></div>;
    $[8] = nicTotal;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== repTotal) {
    t6 = !!repTotal && <div className="tw-flex tw-items-center tw-justify-between"><span className="tw-text-xs tw-font-medium tw-text-iron-300">Rep</span><span className="tw-text-xs tw-font-medium tw-text-purple-200/90">{repTotal}</span></div>;
    $[10] = repTotal;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== manualOutcomes) {
    t7 = manualOutcomes.map(_temp2);
    $[12] = manualOutcomes;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="tw-min-w-[200px] tw-space-y-3 tw-p-3"><div className="tw-space-y-2">{t4}<div className="tw-space-y-1.5">{t5}{t6}{t7}</div></div></div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const tooltipContent = t8;
  const t9 = `tw-flex tw-items-center tw-rounded-lg tw-border tw-border-solid tw-border-iron-700/50 tw-bg-iron-900/60 tw-px-3 tw-py-1.5 tw-backdrop-blur-sm tw-transition-colors tw-duration-200 desktop-hover:hover:tw-border-iron-600/50 desktop-hover:hover:tw-bg-iron-800/60 ${isTouch ? "tw-cursor-pointer" : ""}`;
  const t10 = `wave-outcomes-${drop.id}`;
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="tw-text-xs tw-font-medium tw-text-iron-400">Outcome</span>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== handleClick || $[20] !== t10 || $[21] !== t9) {
    t12 = <button onClick={handleClick} className={t9} data-tooltip-id={t10}>{t11}</button>;
    $[19] = handleClick;
    $[20] = t10;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = `wave-outcomes-${drop.id}`;
  let t14;
  let t15;
  let t16;
  if ($[23] !== isTouch) {
    t14 = isTouch ? {
      click: true
    } : {
      mouseenter: true
    };
    t15 = isTouch ? {
      click: true
    } : {
      mouseleave: true
    };
    t16 = isTouch ? {
      clickOutsideAnchor: true
    } : {};
    $[23] = isTouch;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t14 = $[24];
    t15 = $[25];
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t13 || $[28] !== t14 || $[29] !== t15 || $[30] !== t16 || $[31] !== tooltipContent) {
    t17 = <Tooltip id={t13} place="top" offset={8} opacity={1} positionStrategy="fixed" style={TOOLTIP_STYLES} clickable={true} openEvents={t14} closeEvents={t15} globalCloseEvents={t16}>{tooltipContent}</Tooltip>;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
    $[31] = tooltipContent;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t12 || $[34] !== t17) {
    t18 = <>{t12}{t17}</>;
    $[33] = t12;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  return t18;
};
function _temp() {
  return typeof globalThis !== "undefined" && "ontouchstart" in globalThis;
}
function _temp2(outcome) {
  return <div key={outcome} className="tw-flex tw-items-center tw-justify-between"><span className="tw-text-xs tw-font-medium tw-text-amber-100/90">{outcome}</span></div>;
}